import { render, staticRenderFns } from "./ClientContract.vue?vue&type=template&id=23f04adc&scoped=true&"
import script from "./ClientContract.vue?vue&type=script&lang=js&"
export * from "./ClientContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f04adc",
  null
  
)

export default component.exports